import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../../BasketFinancePaymentSelectionStyled';
import { rem } from 'polished';

export const BasketFinancePaymentSelectionOV = styled(BasketSelectSectionStyled)`
    .section {
        .title {
            font-size: ${rem('16px')};
            .icon {
                .selected {
                    width: ${rem('16px')};
                    height: ${rem('16px')};
                    top: ${rem('3px')};
                    left: ${rem('3px')};
                }
            }
        }
        .description {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            color: ${({ theme }) => theme.colors.black2};
        }
        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.white};
        }

        &.selected {
            background: ${({ theme }) => theme.colors.red7};
            .title .icon {
                border-color: ${({ theme }) => theme.colors.primary};
                span {
                    background: ${({ theme }) => theme.colors.primary};
                    width: ${rem('16px')};
                    height: ${rem('16px')};
                    top: ${rem('3px')};
                    left: ${rem('3px')};
                    position: absolute;
                    border-radius: 50%;
                }
            }
        }
        .summary {
            .totalPrice {
                font-size: ${rem(20)};
                color: ${({ theme }) => theme.colors.black2};
            }
            .otherPrices {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                color: ${({ theme }) => theme.colors.black2};
            }
        }
    }
`;
